import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { Alert as MuiAlert } from '@material-ui/lab';
import { checkStripeConnectCustomUser } from '@api/user';
import { Button } from '@material-ui/core';
import { userIsCrossBorder } from '@utils/helpers';

export default function StripeVerificationWarning({ user }) {
  const [hasRequirements, setHasRequirements] = useState(false);
  const history = useHistory();

  const paymentsCompanies = [
    '60a6454e721adb56e3886271',
    '67c80b16b3b0dbdcf83d6bbb',
    '6641fa779dc970ab3ff8460c',
  ];
  const isPaymentsCompany = (user?.companyId && paymentsCompanies.includes(user.companyId.toString())) || user?.profile?.payments?.isPaymentsAccount === true;

  useEffect(() => {
    if (isPaymentsCompany) {
      setHasRequirements(false);
      return;
    }

    // Only check if user has a custom Stripe account setup
    if (user?.profile?.stripeConnectCustom?.id) {
      async function fetchStatus() {
        try {
          const response = await checkStripeConnectCustomUser();
          const status = response.data;

          const userCountry = user?.profile?.country;
          const isCrossBorderUser = userIsCrossBorder(userCountry);
          const caps = status.capabilities;
          const isCapsActive = isCrossBorderUser
            ? caps?.transfers === 'active'
            : caps?.card_payments === 'active' && caps?.transfers === 'active';

          const hasBlockingRequirements =
            (status.requirements?.currently_due && status.requirements.currently_due.length > 0) ||
            (status.requirements?.past_due && status.requirements.past_due.length > 0);

          setHasRequirements(!isCapsActive || hasBlockingRequirements);
        } catch (e) {
          console.error('Failed to check Stripe verification status:', e);
        }
      }
      fetchStatus();
    }
  }, [user, isPaymentsCompany]);

  if (isPaymentsCompany || !hasRequirements) {
    return null;
  }

  return (
    <MuiAlert
      severity="warning"
      style={{
        width: '100%',
        marginBottom: '16px',
        borderRadius: '12px',
        boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.1)',
        display: 'flex',
        alignItems: 'center',
        padding: '12px 16px'
      }}
      action={
        <Button
          color="inherit"
          size="small"
          onClick={() => history.push('/payoutlink')}
          style={{
            fontWeight: 'bold',
            textTransform: 'none',
            border: '1px solid',
            borderRadius: '6px',
            padding: '4px 12px',
            whiteSpace: 'nowrap'
          }}
        >
          Verify Account
        </Button>
      }
    >
      <strong>Additional Information Required.</strong> Stripe requires some additional details to verify your account and ensure your payouts aren't interrupted.
    </MuiAlert>
  );
}
